export default "__VITE_ASSET__9c766b82__"